import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const orderTypeDict: Array<Dictionary> = []

enum orderTypes {
    INTERNET_SHOP = 'internet_shop',
    DELIVERY = 'delivery'
}

for (const code of Object.values(orderTypes)) {
    orderTypeDict.push(
        {
            code,
            name: i18n.t(`dictionary.orderType.${code}`).toString()
        }
    )
}

export { orderTypes, orderTypeDict }
